/* OmyBoat collection-filters.js v3 — multi-select port/ville + BTA */
(function(){
'use strict';
var isEN = /\/en(\/|$)/.test(window.location.pathname);

// ── État ───────────────────────────────────────────────────────────────────
var selVilles = new Set(); // slugs de villes sélectionnées
var selPorts  = new Set(); // slugs de port_attache sélectionnés
var acIdx = -1;

// ── Helpers ────────────────────────────────────────────────────────────────
function norm(s){ return (s||'').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g,'').replace(/[-_]/g,' ').trim(); }
function getWrap(){ var g=document.getElementById('boatsGrid'); return g ? Array.from(g.querySelectorAll('.boat-card-wrapper')) : []; }

function getDates(){
  var pF=window.pickerCollectionFrom, pT=window.pickerCollectionTo;
  return {
    dateFrom: pF && pF.input ? pF.input.value : '',
    dateTo:   pT && pT.input ? pT.input.value : ''
  };
}

// ── Lire les filtres ───────────────────────────────────────────────────────
function getF(){
  var d = getDates();
  return {
    villes:   Array.from(selVilles),
    ports:    Array.from(selPorts),
    type:     norm(document.getElementById('filterType')?.value||''),
    pmin:     parseFloat(document.getElementById('filterPriceMin')?.value)||0,
    pmax:     parseFloat(document.getElementById('filterPriceMax')?.value)||Infinity,
    cap:      parseInt(document.getElementById('filterCapacity')?.value)||0,
    lmin:     parseFloat(document.getElementById('filterLengthMin')?.value)||0,
    lmax:     parseFloat(document.getElementById('filterLengthMax')?.value)||Infinity,
    permit:   document.getElementById('filterNoPermit')?.checked,
    gps:      document.getElementById('filterGPS')?.checked,
    douche:   document.getElementById('filterDouche')?.checked,
    bimini:   document.getElementById('filterBimini')?.checked,
    skipper:  document.getElementById('filterSkipper')?.checked,
    dateFrom: d.dateFrom,
    dateTo:   d.dateTo
  };
}

// ── Appliquer les filtres ──────────────────────────────────────────────────
function apply(){
  var f = getF();
  var ws = getWrap();
  var vis = 0;
  var hasLocFilter = f.villes.length > 0 || f.ports.length > 0;

  ws.forEach(function(w){
    var pr     = parseFloat(w.dataset.price)||0;
    var cap    = parseInt(w.dataset.capacity)||0;
    var len    = parseFloat(w.dataset.length)||0;
    var permit = w.dataset.permit === 'true';
    var ville  = norm(w.dataset.ville || w.dataset.port || '');
    var portAt = norm(w.dataset.portAttache || '');
    var type   = norm(w.dataset.type || '');
    var show   = true;

    // Localisation : OR entre villes et ports
    if(hasLocFilter){
      var villeMatch = f.villes.some(function(v){ return norm(v) === ville; });
      var portMatch  = f.ports.some(function(p){ return norm(p) === portAt; });
      if(!villeMatch && !portMatch) show = false;
    }

    if(f.type   && !type.includes(norm(f.type)))          show = false;
    if(f.pmin   && pr < f.pmin)                           show = false;
    if(f.pmax   < Infinity && pr > f.pmax)                show = false;
    if(f.cap    && cap < f.cap)                           show = false;
    if(f.lmin   && len < f.lmin)                          show = false;
    if(f.lmax   < Infinity && len > f.lmax)               show = false;
    if(f.permit && permit !== false)                       show = false;
    if(f.gps    && w.dataset.gps !== 'true')              show = false;
    if(f.douche && w.dataset.douche !== 'true')           show = false;
    if(f.bimini && w.dataset.bimini !== 'true')           show = false;
    if(f.skipper && w.dataset.skipper   !== 'true')       show = false;
    if(w.dataset.btaAvailable === 'false')                show = false;

    w.style.display = show ? '' : 'none';
    if(show) vis++;
  });

  var sv = document.getElementById('sortSelect')?.value;
  if(sv) sortRes(sv);
  updCount(vis, ws.length);
  renderTags(f);
  updateURL(f);
  var nr = document.getElementById('noResults');
  if(nr) nr.style.display = vis === 0 ? 'block' : 'none';
  if (vis === 0) {
    if (typeof window.showNearestBoats === 'function') window.showNearestBoats(f);
  } else if (vis < ws.length) {
    // Il reste des bateaux cachés → les afficher en bas comme "Voir aussi"
    if (typeof window.showNearestBoatsAfterResults === 'function') window.showNearestBoatsAfterResults(f, ws);
    else if (typeof window.hideNearestBoats === 'function') window.hideNearestBoats();
  } else {
    if (typeof window.hideNearestBoats === 'function') window.hideNearestBoats();
  }
}

// Exposer pour BTA
window.omyboatFiltersApply  = apply;
window.omyboatFiltersRefresh = apply;

// ── Sort ───────────────────────────────────────────────────────────────────
function sortRes(sv){
  var g = document.getElementById('boatsGrid'); if(!g) return;
  var ws = Array.from(g.querySelectorAll('.boat-card-wrapper')).filter(function(w){ return w.style.display !== 'none'; });
  ws.sort(function(a,b){
    if(sv==='price-asc')     return (parseFloat(a.dataset.price)||0)-(parseFloat(b.dataset.price)||0);
    if(sv==='price-desc')    return (parseFloat(b.dataset.price)||0)-(parseFloat(a.dataset.price)||0);
    if(sv==='capacity-desc') return (parseInt(b.dataset.capacity)||0)-(parseInt(a.dataset.capacity)||0);
    if(sv==='length-desc')   return (parseFloat(b.dataset.length)||0)-(parseFloat(a.dataset.length)||0);
    return 0;
  });
  ws.forEach(function(w){ g.appendChild(w); });
}

// ── Compteur ───────────────────────────────────────────────────────────────
function updCount(v, t){
  var lbl = isEN ? (v+' boat'+(v>1?'s':'')+' available') : (v+' bateau'+(v>1?'x':'')+' disponible'+(v>1?'s':''));
  var sc = document.getElementById('sidebarCount'); if(sc) sc.textContent = lbl;
  var cc = document.getElementById('collectionCount'); if(cc) cc.textContent = v < t ? '('+v+'/'+t+')' : '';
}

// ── Format date ────────────────────────────────────────────────────────────
function fmtD(d){ var p=(d||'').split('-'); return p.length===3?p[2]+'/'+p[1]+'/'+p[0]:d; }

// ── Chips filtres actifs ───────────────────────────────────────────────────
function renderTags(f){
  var c = document.getElementById('activeTags'); if(!c) return;
  var tags = [];
  var allPorts  = window.OMYBOAT_PORTS_COLLECTION  || [];
  var allVilles = window.OMYBOAT_VILLES_COLLECTION || [];

  f.villes.forEach(function(slug){
    var v = allVilles.find(function(x){ return x.slug === slug; });
    var lbl = '📍 '+(v ? v.nom : slug)+(isEN ? ' (whole city)' : ' (toute la ville)');
    tags.push({ l: lbl, fn: (function(s){ return function(){ selVilles.delete(s); uncheckVille(s); }; })(slug) });
  });
  f.ports.forEach(function(slug){
    var p = allPorts.find(function(x){ return x.slug === slug; });
    var lbl = '⚓ '+(p ? p.nom : slug);
    tags.push({ l: lbl, fn: (function(s){ return function(){ selPorts.delete(s); uncheckPort(s); }; })(slug) });
  });

  if(f.type)   tags.push({l:'⛵ '+f.type,   fn:function(){ document.getElementById('filterType').value=''; }});
  if(f.pmin||f.pmax<Infinity) tags.push({l:'💶 '+(f.pmin||0)+'€'+(f.pmax<Infinity?'-'+f.pmax+'€':'+'), fn:function(){ document.getElementById('filterPriceMin').value=''; document.getElementById('filterPriceMax').value=''; }});
  if(f.cap)    tags.push({l:'👥 '+f.cap+'+', fn:function(){ document.getElementById('filterCapacity').value=''; }});
  if(f.permit) tags.push({l: isEN ? '⚓ No license' : '⚓ Sans permis', fn:function(){ document.getElementById('filterNoPermit').checked=false; }});
  if(f.gps)    tags.push({l:'🧭 GPS',    fn:function(){ document.getElementById('filterGPS').checked=false; }});
  if(f.douche) tags.push({l:'🚿 Douche', fn:function(){ document.getElementById('filterDouche').checked=false; }});
  if(f.bimini) tags.push({l:'☀️ Bimini', fn:function(){ document.getElementById('filterBimini').checked=false; }});
  if(f.skipper) tags.push({l: isEN ? '🧑‍✈️ With skipper' : '🧑‍✈️ Avec skipper', fn:function(){ document.getElementById('filterSkipper').checked=false; }});
  if(f.dateFrom && f.dateTo){
    tags.push({
      l: '📅 '+fmtD(f.dateFrom)+' → '+fmtD(f.dateTo),
      fn: function(){
        if(window.pickerCollectionFrom) window.pickerCollectionFrom.clear();
        if(window.pickerCollectionTo)   window.pickerCollectionTo.clear();
        var btn=document.getElementById('filterDateClearBtn'); if(btn) btn.style.display='none';
        if(typeof window.clearBtaCheck==='function') window.clearBtaCheck();
        var p=new URLSearchParams(window.location.search);
        p.delete('date_from'); p.delete('date_to');
        history.replaceState(null,'',window.location.pathname+(p.toString()?'?'+p.toString():''));
      }
    });
  }

  if(!tags.length){ c.innerHTML=''; return; }
  c.innerHTML = tags.map(function(t,i){
    return '<span class="filter-tag">'+t.l+' <span class="filter-tag-x" data-i="'+i+'">✕</span></span>';
  }).join('')+(tags.length>1?'<button class="filter-clear-all" id="cAll">'+(isEN?'Clear all':'Tout effacer')+'</button>':'');
  c.querySelectorAll('.filter-tag-x').forEach(function(b){
    b.addEventListener('click', function(){ tags[+b.dataset.i].fn(); apply(); });
  });
  var ca=c.querySelector('#cAll'); if(ca) ca.addEventListener('click', reset);
}

// ── Uncheck helpers ────────────────────────────────────────────────────────
function uncheckVille(slug){
  var cb=document.querySelector('.filterPortVille[value="'+slug+'"]');
  if(cb){ cb.checked=false; }
  refreshCityHeader(slug);
  updateAccordionClear();
}
function uncheckPort(slug){
  var cb=document.querySelector('.filterPortAttache[value="'+slug+'"]');
  if(cb){ refreshCityHeader(cb.dataset.ville); cb.checked=false; }
  updateAccordionClear();
}
function refreshCityHeader(villeSlug){
  if(!villeSlug) return;
  var city=document.querySelector('.port-city[data-slug="'+villeSlug+'"]'); if(!city) return;
  var anyChecked=Array.from(city.querySelectorAll('input[type=checkbox]')).some(function(x){ return x.checked; });
  city.querySelector('.port-city-header')?.classList.toggle('has-selection', anyChecked);
}
function updateAccordionClear(){
  var ac=document.getElementById('portAccordionClear'); if(!ac) return;
  ac.classList.toggle('visible', selVilles.size>0||selPorts.size>0);
}

// ── Reset ──────────────────────────────────────────────────────────────────
function reset(){
  selVilles.clear(); selPorts.clear();
  document.querySelectorAll('.filterPortVille,.filterPortAttache').forEach(function(cb){ cb.checked=false; });
  document.querySelectorAll('.port-city-header').forEach(function(h){ h.classList.remove('has-selection'); });
  updateAccordionClear();
  clearSearchUI();
  ['filterType','filterCapacity','sortSelect'].forEach(function(id){ var e=document.getElementById(id); if(e) e.value=''; });
  ['filterPriceMin','filterPriceMax','filterLengthMin','filterLengthMax'].forEach(function(id){ var e=document.getElementById(id); if(e) e.value=''; });
  ['filterNoPermit','filterGPS','filterDouche','filterBimini','filterSkipper'].forEach(function(id){ var e=document.getElementById(id); if(e) e.checked=false; });
  if(window.pickerCollectionFrom) window.pickerCollectionFrom.clear();
  if(window.pickerCollectionTo)   window.pickerCollectionTo.clear();
  var clearBtn=document.getElementById('filterDateClearBtn'); if(clearBtn) clearBtn.style.display='none';
  if(typeof window.clearBtaCheck==='function') window.clearBtaCheck();
  history.replaceState(null,'',window.location.pathname);
  apply();
}

// ── Port search input ──────────────────────────────────────────────────────
function clearSearchUI(){
  var inp=document.getElementById('portSearchInput'); if(inp) inp.value='';
  var cb=document.getElementById('portSearchClearBtn'); if(cb) cb.classList.remove('visible');
  closeDrop();
}
function closeDrop(){ var dd=document.getElementById('portAutocomplete'); if(dd){ dd.innerHTML=''; dd.classList.remove('open'); } acIdx=-1; }

function searchV(q){ return (window.OMYBOAT_VILLES_COLLECTION||[]).filter(function(v){ return norm(v.nom).includes(norm(q))||norm(v.slug).includes(norm(q)); }).slice(0,8); }

function renderAC(q){
  var dd=document.getElementById('portAutocomplete'); if(!dd) return;
  var res=searchV(q); acIdx=-1;
  if(!q.trim()){ dd.innerHTML=''; dd.classList.remove('open'); return; }
  if(!res.length){ dd.innerHTML='<div class="port-ac-empty">'+(isEN?'No marina found':'Aucun port trouvé')+'</div>'; }
  else{
    dd.innerHTML=res.map(function(v,i){
      var sel=selVilles.has(v.slug);
      return '<div class="port-ac-item'+(sel?' port-ac-item--sel':'')+'" data-i="'+i+'" data-slug="'+v.slug+'">'
        +'<div class="port-ac-item-name">'+v.emoji+' '+v.nom+(sel?' ✓':'')+'</div>'
        +'<div class="port-ac-item-sub">'+v.dept+'</div></div>';
    }).join('');
    dd.querySelectorAll('.port-ac-item').forEach(function(item){
      item.addEventListener('mousedown',function(e){
        e.preventDefault();
        var slug=item.dataset.slug;
        if(selVilles.has(slug)){ selVilles.delete(slug); uncheckVille(slug); }
        else { selVilles.add(slug); setVilleChecked(slug); }
        closeDrop();
        var inp=document.getElementById('portSearchInput'); if(inp) inp.value='';
        document.getElementById('portSearchClearBtn')?.classList.toggle('visible', selVilles.size>0||selPorts.size>0);
        apply();
      });
    });
  }
  dd.classList.add('open');
}

// ── Accordion ──────────────────────────────────────────────────────────────
function checkAllPortsOfVille(slug, checked){
  document.querySelectorAll('.filterPortAttache[data-ville="'+slug+'"]').forEach(function(p){
    p.checked = checked;
    if(checked) selPorts.add(p.value);
    else        selPorts.delete(p.value);
  });
}

function setVilleChecked(slug){
  var cb=document.querySelector('.filterPortVille[value="'+slug+'"]');
  if(cb){
    cb.checked=true;
    cb.closest('.port-city')?.classList.add('open');
    // Si multi-port : cocher aussi tous les ports
    if(cb.dataset.multiport==='true') checkAllPortsOfVille(slug, true);
  }
  refreshCityHeader(slug);
  updateAccordionClear();
}

function initAccordion(){
  // Toggle accordion uniquement sur .port-city-toggle (nom + chevron)
  document.querySelectorAll('.port-city-header').forEach(function(h){
    h.addEventListener('click',function(e){
      if(e.target.closest('.port-city-toggle')) {
        h.closest('.port-city').classList.toggle('open');
      }
    });
  });

  // Ville checkbox
  document.querySelectorAll('.filterPortVille').forEach(function(cb){
    cb.addEventListener('change',function(){
      var slug = cb.value;
      var isMulti = cb.dataset.multiport === 'true';
      if(cb.checked){
        selVilles.add(slug);
        cb.closest('.port-city')?.classList.add('open');
        // Multi-port : cocher tous les sous-ports
        if(isMulti) checkAllPortsOfVille(slug, true);
      } else {
        selVilles.delete(slug);
        // Multi-port : décocher tous les sous-ports
        if(isMulti) checkAllPortsOfVille(slug, false);
      }
      refreshCityHeader(slug);
      updateAccordionClear();
      apply();
    });
  });

  // Port checkbox
  document.querySelectorAll('.filterPortAttache').forEach(function(cb){
    cb.addEventListener('change',function(){
      var villeSlug = cb.dataset.ville;
      if(cb.checked){
        selPorts.add(cb.value);
      } else {
        selPorts.delete(cb.value);
        // Décocher la ville parente si elle était cochée
        var villeCb = document.querySelector('.filterPortVille[value="'+villeSlug+'"]');
        if(villeCb && villeCb.checked){
          villeCb.checked = false;
          selVilles.delete(villeSlug);
        }
      }
      refreshCityHeader(villeSlug);
      updateAccordionClear();
      apply();
    });
  });

  document.getElementById('portAccordionClear')?.addEventListener('click',function(){
    selVilles.clear(); selPorts.clear();
    document.querySelectorAll('.filterPortVille,.filterPortAttache').forEach(function(cb){ cb.checked=false; });
    document.querySelectorAll('.port-city-header').forEach(function(h){ h.classList.remove('has-selection'); });
    updateAccordionClear();
    apply();
  });
}

// ── Mobile sidebar ─────────────────────────────────────────────────────────
function initMobile(){
  var ov=document.createElement('div'); ov.className='filters-overlay'; document.body.appendChild(ov);
  var sb=document.getElementById('filtersSidebar');
  var open =function(){ sb?.classList.add('open'); ov.classList.add('active'); document.body.style.overflow='hidden'; };
  var close=function(){ sb?.classList.remove('open'); ov.classList.remove('active'); document.body.style.overflow=''; };
  document.getElementById('filtersToggleBtn')?.addEventListener('click',open);
  document.getElementById('filtersCloseBtn')?.addEventListener('click',close);
  ov.addEventListener('click',close);
}

// ── URL ────────────────────────────────────────────────────────────────────
function updateURL(f){
  var p=new URLSearchParams(window.location.search);
  if(f.villes.length) p.set('villes',f.villes.join(',')); else p.delete('villes');
  if(f.ports.length)  p.set('ports', f.ports.join(','));  else p.delete('ports');
  if(f.type)          p.set('type',f.type);    else p.delete('type');
  if(f.pmin)          p.set('pmin',f.pmin);    else p.delete('pmin');
  if(f.pmax<Infinity) p.set('pmax',f.pmax);    else p.delete('pmax');
  if(f.cap)           p.set('cap',f.cap);      else p.delete('cap');
  if(f.permit)        p.set('permit','0');       else p.delete('permit');
  if(f.skipper)       p.set('skipper','1');      else p.delete('skipper');
  var qs=p.toString();
  history.replaceState(null,'',qs?'?'+qs:window.location.pathname);
}

function readURL(){
  var p=new URLSearchParams(window.location.search);
  var vStr=p.get('villes'), pStr=p.get('ports');
  if(vStr) vStr.split(',').forEach(function(s){ if(s) selVilles.add(s); });
  if(pStr) pStr.split(',').forEach(function(s){ if(s) selPorts.add(s); });
  selVilles.forEach(function(slug){ setVilleChecked(slug); });
  selPorts.forEach(function(slug){
    var cb=document.querySelector('.filterPortAttache[value="'+slug+'"]');
    if(cb){ cb.checked=true; refreshCityHeader(cb.dataset.ville); }
  });
  if(p.get('type')){
    var selType=document.getElementById('filterType');
    if(selType){
      var tn=norm(p.get('type'));
      var optMatch=Array.from(selType.options).find(function(o){ return o.value && norm(o.value)===tn; });
      if(optMatch) selType.value=optMatch.value;
    }
  }
  if(p.get('pmin')){ var e2=document.getElementById('filterPriceMin'); if(e2) e2.value=p.get('pmin'); }
  if(p.get('pmax')){ var e3=document.getElementById('filterPriceMax'); if(e3) e3.value=p.get('pmax'); }
  if(p.get('cap')){ var e4=document.getElementById('filterCapacity'); if(e4) e4.value=p.get('cap'); }
  if(p.get('permit')==='0'){ var e5=document.getElementById('filterNoPermit'); if(e5) e5.checked=true; }
  if(p.get('skipper')==='1'){ var e6=document.getElementById('filterSkipper'); if(e6) e6.checked=true; }
  updateAccordionClear();
}

// ── Init ───────────────────────────────────────────────────────────────────
document.addEventListener('DOMContentLoaded',function(){
  var inp=document.getElementById('portSearchInput');
  if(inp){
    inp.addEventListener('input',function(){ renderAC(inp.value); document.getElementById('portSearchClearBtn')?.classList.toggle('visible',inp.value.length>0); });
    inp.addEventListener('keydown',function(e){
      var dd=document.getElementById('portAutocomplete');
      var items=dd?dd.querySelectorAll('.port-ac-item'):[];
      if(e.key==='ArrowDown'){ acIdx=Math.min(acIdx+1,items.length-1); }
      else if(e.key==='ArrowUp'){ acIdx=Math.max(acIdx-1,-1); }
      else if(e.key==='Enter'&&acIdx>=0){ items[acIdx]?.dispatchEvent(new Event('mousedown')); }
      else if(e.key==='Escape'){ closeDrop(); }
      items.forEach(function(item,i){ item.classList.toggle('active',i===acIdx); });
    });
    inp.addEventListener('blur',function(){ setTimeout(closeDrop,150); });
  }

  document.getElementById('portSearchClearBtn')?.addEventListener('click',function(){
    selVilles.clear(); selPorts.clear();
    document.querySelectorAll('.filterPortVille,.filterPortAttache').forEach(function(cb){ cb.checked=false; });
    document.querySelectorAll('.port-city-header').forEach(function(h){ h.classList.remove('has-selection'); });
    updateAccordionClear();
    clearSearchUI();
    apply();
  });

  document.getElementById('filterApplyBtn')?.addEventListener('click',apply);
  document.getElementById('filterResetBtn')?.addEventListener('click',reset);
  document.getElementById('sortSelect')?.addEventListener('change',apply);
  ['filterType','filterCapacity'].forEach(function(id){ document.getElementById(id)?.addEventListener('change',apply); });
  ['filterPriceMin','filterPriceMax','filterLengthMin','filterLengthMax'].forEach(function(id){ document.getElementById(id)?.addEventListener('change',apply); });
  ['filterNoPermit','filterGPS','filterDouche','filterBimini','filterSkipper'].forEach(function(id){ document.getElementById(id)?.addEventListener('change',apply); });

  initAccordion();
  initMobile();
  readURL();
  apply();
});

})();


